import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-editorial py-32 md:py-40" data-testid="not-found-page">
      <div className="max-w-xl">
        <div className="eyebrow">Error · 404</div>
        <h1 className="font-serif text-6xl md:text-7xl tracking-tight leading-[0.95] text-[#0C1D36] mt-6">
          Page not found.
        </h1>
        <p className="mt-6 text-lg text-[#0C1D36]/75">
          The page you're looking for has moved, been renamed, or never existed. No
          reconciliation errors were harmed in the making of this 404.
        </p>
        <Link to="/" className="btn-primary mt-10" data-testid="not-found-home">
          Return Home
        </Link>
      </div>
    </section>
  );
}
